<template>
    <el-dialog
        :visible.sync="show"
        append-to-body
        width="70%"
        class="bom-dialog"
        :close-on-click-modal="false"
        :before-close="closeDialog"
        :center="true"
    >
        <template slot="title">
            <div class="dialog-title">
                报价拆解
            </div>
        </template>
        <div class="container">
            <div class="xx-h2">
                基本信息
            </div>
            <xx-form
                label-width="120px"
                class="xx-layout-form"
                inline
                :showMessage="false"
            >
                <xx-form-item
                    label="skuId:"
                >
                    <span>
                        {{ rowData.skuId }}
                    </span>
                </xx-form-item>
                <xx-form-item
                    label="商品名称:"
                >
                    <span>
                        {{ rowData.skuName }}
                    </span>
                </xx-form-item>
                <xx-form-item
                    label="供应商利润率:"
                >
                    <span>
                        {{ rowData.profitMargin ? `${rowData.profitMargin}%` : '--' }}
                    </span>
                </xx-form-item>
            </xx-form>
            <xx-form
                ref="bomDetailEditForm"
                :model="bomDetailForm"
                label-width="180px"
                :disabled="!editable"
            >
                <div
                    v-for="item in extraBomHeader"
                    :key="item.parentName"
                >
                    <div
                        class="xx-h2"
                    >
                        {{ item.parentName }}
                    </div>
                    <div
                        class="bom-detail-form"
                    >
                        <xx-form-item
                            v-for="childItem in item.childPrice"
                            :key="childItem.column"
                            :label="getFormItemLabel(childItem)"
                            :description="childItem.description"
                            description-position="tooltip"
                            :prop="childItem.column"
                            :rules="getInputRule(childItem.ifRequired)"
                            size="small"
                        >
                            <el-input
                                v-model="bomDetailForm[childItem.column]"
                                type="number"
                                :min="0"
                                class="price-input"
                            />
                        </xx-form-item>
                    </div>
                </div>
            </xx-form>
        </div>
        <div
            v-if="editable"
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                type="default"
                @click="resetDialogData"
            >
                重置
            </el-button>
            <el-button
                type="primary"
                @click="submit"
            >
                保存
            </el-button>
        </div>
    </el-dialog>
</template>
<script>
import Rules from '@lsfe/rules';
import { cloneDeep } from '@lsfe/tools';
import { valueTypeEnumMap, unitTypeEnumMap } from '../config';

export default {
    components: {},
    data() {
        return {
            show: false,
            bomDetailDefaultForm: {}, // 默认表单项配置
            bomDetailForm: {},
            rowData: {},
            bomColumns: [],
            extraBomHeader: [],
            valueList: [],
            editable: true,
        };
    },
    computed: {

    },
    watch: {

    },
    methods: {
        popup(params) {
            this.editable = params.editable;
            this.rowData = params.row || {};
            this.bomColumns = params.bomColumns || [];
            this.valueList = params.row.columnValueList || [];
            this.extraBomHeader = params.extraBomHeader || [];
            this.bomColumns.forEach((item) => {
                this.bomDetailDefaultForm[item.column] = '';
            });
            this.bomDetailForm = cloneDeep(this.bomDetailDefaultForm);
            this.valueList.forEach((item) => {
                this.bomDetailForm[item.column] = item.value;
            });
            if (this.$refs.bomDetailEditForm) {
                this.$refs.bomDetailEditForm.clearValidate();
            }
            this.show = true;
        },
        // 重置弹窗数据
        resetDialogData() {
            this.bomDetailForm = cloneDeep(this.bomDetailDefaultForm);
        },
        async closeDialog(done) {
            if (this.editable) {
                try {
                    await this.$confirm('关闭将不保存已填写或修改的信息，确定关闭吗？', '提示', {
                        confirmButtonText: '确定关闭',
                        cancelButtonText: '继续编辑',
                        type: 'warning',
                    });
                    this.resetDialogData();
                    this.$refs.bomDetailEditForm.clearValidate();
                } catch (err) {
                    return;
                }
            } else {
                this.resetDialogData();
                this.$refs.bomDetailEditForm.clearValidate();
            }
            done();
        },
        getInputRule(ifRequired) {
            const defaultRules = [
                Rules.typeValid({ type: 'number' }, '请填写数字'),
                Rules.range({ min: 0 }, '费用大于等于0'),
                Rules.decimalLen({ len: 2 }, '最多保留两位小数'),
            ];
            // ifRequired: 1-必填、2-非必填
            // priorityType(是否为重点品): 0-非重点品、1-重点品 非重点品的BOM拆解为非必填
            if (ifRequired === 1 && this.rowData.priorityType === 1) {
                defaultRules.push(Rules.isRequired('请输入成本项'));
            }
            return defaultRules;
        },
        getFormItemLabel(childItem) {
            // 计价单位为"-",不进行展示
            if (unitTypeEnumMap[childItem.unit] === '-') {
                return `${childItem.name}(${valueTypeEnumMap[childItem.valueType]})`;
            } else {
                return `${childItem.name}(${valueTypeEnumMap[childItem.valueType]}/${unitTypeEnumMap[childItem.unit]})`;
            }
        },
        async submit() {
            try {
                const valid = await this.$refs.bomDetailEditForm.validate();
                if (valid) {
                    const bomValueList = this.bomColumns.map((v) => ({
                        name: v.name,
                        column: v.column,
                        value: this.bomDetailForm[v.column] === 0 || this.bomDetailForm[v.column] ? Number(this.bomDetailForm[v.column]) : null,
                    }));
                    this.$emit('updateData', { columnValueList: bomValueList, index: this.rowData.index });
                    this.$message.success('保存成功');
                    this.resetDialogData();
                    this.$refs.bomDetailEditForm.clearValidate();
                    this.show = false;
                }
            } catch (err) {
                this.$message.error('请根据提示信息修改输入值!');
            }
        },
    },
};
</script>
<style scoped lang="scss">
.bom-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/ .el-dialog__body {
        padding-top: 10px;
    }
    .dialog-title {
            font-size: 18px;
            color: #409eff;
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 500;
            padding: 24px;
        }
    .container {
        overflow-y: auto;
        height: 550px;
        .bom-detail-form {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            .price-input {
                display: inline-block;
                width: 150px
            }
        }
    }
}
</style>
